var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAureaNlogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "181px",
    height: "43.9996178px",
    viewBox: "0 0 181 43.9996178",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 47") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 44 181 44 181 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MERCADO-SECUND\\xC1RIO",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-AUREA-1600",
    transform: "translate(-208, -820.0003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(208, 820)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#DCAA5A",
    points: "0 43.4642257 10.6204839 43.4642257 15.9057594 30.5270962 10.5952797 17.5675115"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#FEFEFE",
    points: "21.2156685 17.567177 15.9056643 30.5267618 21.2151929 43.464369 31.8361524 43.464369"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#AC793D",
    points: "10.5954224 17.567177 15.9054265 30.5267618 21.2154307 17.567177"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#DCAA5A",
    points: "17.717324 0.000286663626 23.0273282 12.9598714 28.3378079 0.000286663626"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#AC793D",
    points: "21.2156685 17.589489 15.9056643 4.62990423 10.5956601 17.589489"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.9261149,27.8897909 C52.5391292,27.8897909 56.5832162,25.0217213 56.5832162,19.0939953 C56.5832162,14.2656243 52.9195701,10.5848633 47.5910194,10.5848633 L38.5517431,10.5848633 L38.5517431,27.8897909 L45.9261149,27.8897909 Z M37.077059,9.29392143 L47.7341603,9.29392143 C54.3471747,9.29392143 58.1530106,13.5962647 58.1530106,19.0939953 C58.1530106,25.2606076 53.6809275,29.1807327 46.5448069,29.1807327 L38.5517431,29.1807327 L38.5517431,43.3787044 L37.077059,43.3787044 L37.077059,9.29392143 Z",
    id: "Fill-7",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5689998,27.8897909 C80.1820142,27.8897909 84.2261012,25.0217213 84.2261012,19.0939953 C84.2261012,14.2656243 80.5624551,10.5848633 75.2339044,10.5848633 L66.1946281,10.5848633 L66.1946281,27.8897909 L73.5689998,27.8897909 Z M64.719944,9.29392143 L75.3770453,9.29392143 C81.9900597,9.29392143 85.7958955,13.5962647 85.7958955,19.0939953 C85.7958955,25.2606076 81.3238125,29.1807327 74.1876919,29.1807327 L66.1946281,29.1807327 L66.1946281,43.3787044 L64.719944,43.3787044 L64.719944,9.29392143 Z",
    id: "Fill-9",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    fill: "#FEFEFE",
    points: "92.362829 9.29392143 93.8375131 9.29392143 93.8375131 42.0399852 112.392092 42.0399852 112.392092 43.3787044 92.362829 43.3787044"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-14"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    fill: "#FEFEFE",
    mask: "url(#mask-2)",
    points: "118.293349 43.3788955 119.768034 43.3788955 119.768034 9.29411254 118.293349 9.29411254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.047152,32.9571438 L127.047152,20.1934458 C127.047152,13.6919148 131.947707,8.57688014 139.321603,8.57688014 C146.315058,8.57688014 150.644476,12.8792234 150.644476,17.8987035 L150.644476,20.1456686 L149.217347,20.1456686 L149.217347,18.3291767 C149.217347,13.5963602 145.839507,10.0111538 139.083828,10.0111538 C132.613479,10.0111538 128.616947,14.5046062 128.616947,20.3845549 L128.616947,32.431116 C128.616947,38.6459835 132.708589,42.6611853 139.321603,42.6611853 C146.077283,42.6611853 149.217347,39.0282016 149.217347,34.2958629 L149.217347,33.2915847 L150.644476,33.2915847 L150.644476,34.7736356 C150.644476,40.1275566 146.362614,43.9999044 139.321603,43.9999044 C132.233038,43.9999044 127.047152,40.2713662 127.047152,32.9571438",
    id: "Fill-15",
    fill: "#FEFEFE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.529699,29.8020761 L167.726464,10.871288 L167.678909,10.871288 L160.685453,29.8020761 L174.529699,29.8020761 Z M167.012661,9.10257346 L168.535376,9.10257346 L181.000048,43.3784655 L179.430253,43.3784655 L174.957695,31.0925402 L160.256982,31.0925402 L155.784899,43.3784655 L154.310215,43.3784655 L167.012661,9.10257346 Z",
    id: "Fill-16",
    fill: "#FEFEFE",
    mask: "url(#mask-2)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAureaNlogo);
export default __webpack_public_path__ + "static/media/AUREA_nlogo.b454d7921f873a522c8143ba2d92b486.svg";
export { ForwardRef as ReactComponent };